export default __webpack_public_path__ + "static/media/Cooking-cuate.2553c808.svg";